import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.u.any,
      face.m.two,
      face.u.any,
    ],
  ],
  name: '2B',
};
